<template>
    <div
        v-if="path.length"
        :style="{ 'background-image': 'url(' + path + ')' }"
        :class="['bg-cover bg-center bg-norepeat', imageSize[size]]"
    ></div>
</template>

<script>
export default {
    props: {
        path: {
            type: String
        },
        size: {
            type: String,
            default: 'large'
        }
    },

    data: function () {
        return {
            imageSize: {
                small: 'w-32 h-32 md:w-32 md:h-32',
                large: 'w-48 h-48 md:w-48 md:h-48',
                tiny: 'w-24 h-24 md:w-24 md:h-24',
                full: 'w-full h-full'
            }
        }
    }
}
</script>
